import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "visual-positioning-canvas-sizer" }, null, -1)
const _hoisted_2 = { class: "visual-positioning-canvas-visuals" }


export default /*#__PURE__*/_defineComponent({
  __name: 'visual-positioning-canvas',
  props: {
    isFullScreen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["visual-positioning-canvas", { 'full-screen-canvas': props.isFullScreen }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})